<template>
  <div class="search" @keydown.enter="submit()" v-show="show">
    <div class="btn-block">
      <div>
        <sc-btn
          type="primary"
          style="margin-right: 10px"
          :handler="submit"
          text="查询"
        />
        <sc-btn :disabled="!form.canReset.value" :handler="reset" text="重置" />
      </div>
    </div>
    <div style="margin-top: 10px">
      <a-row :gutter="[12, 12]">
        <template v-for="group in groups" :key="group.title">
          <a-col
            :xs="24"
            :sm="12"
            :md="8"
            :lg="8"
            :xl="8"
            :xxl="4"
            v-for="item in group.items"
            :key="item.id"
          >
            <component :is="item.component.value" v-bind="item.props" />
          </a-col>
        </template>
      </a-row>
    </div>
  </div>
</template>

<script setup lang="ts">
import { SearchContainerGroup } from '@/components/business/crud/widgets/SearchWidgetContainer';
import { ScForm } from '@/models/ScForm';

const props = withDefaults(
  defineProps<{
    groups: SearchContainerGroup[];
    form: ScForm;
    show: boolean;
  }>(),
  {
    show: true,
  }
);

const emit = defineEmits<{
  (event: 'search'): void;
}>();

function reset() {
  props.form.reset();
  emit('search');
}

function submit() {
  emit('search');
}
</script>

<style lang="scss" scoped>
.search {
  margin-bottom: $spacing-medium;

  .btn-block {
    display: flex;
    flex-direction: row;
  }

  .search-item {
    display: flex;
    flex-direction: row;

    .label {
      flex-shrink: 0;
      margin-right: $spacing-small;
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    .widget {
      flex-grow: 1;
    }
  }
}
</style>
